import {
    reqLogin,
    reqTempLogin,
    reqTempUserLogin,
    refreshToken,
    regTokenLogin,
} from '../../api/security/login' //'../../api/security/login'
//import VueCookies from 'vue-cookies'
const state = {
    userId: '',
    userGuid: '', //临时用户生成一个随机的GUID，固定IP的企业用户从未使用的用户中找一个
    realName: '',
    token: '',
    mobileNum: '',
    //企业相关
    //userType: '', ////temp 为临时用户，fixedip 为固定IP地址的企业用户
    permission: [],
    isLogin: false,
    screen: false,
    sliderLength: 0,
    isLeftExpand: true, //是否展开左侧导航菜单
    popLoginForm: false,
    selectNode: null,
    localinfo: {},
    tempLoginFalureTime: 0,
    initData: {
        leftTree: [],
        leftTMTree: [],
        industry: [],
        taxes: [],
        inOut: [],
        reduction: [],
        reductionTax: [],
        reductionIndustry: [],
        country: [],
        provinceCity: [],
        offersIndustry: [],
        currentVersion: '2',
        court:[],
        taxCaseCategory:[],
        paperword:[],
    },
    loginUser: {
        userId: '',
        phone: '',
        realName: '',
        token: '',
    },
    workbook: {
        isContentChanged: false,
        submitLeft: 5, //剩余提交次数
        readfiles: [], //已读文件
        historyfiles: [], //历史文件
        readfilesSelected: [], //用户已选择的关联文件
    },
    sysconfig: {
        pages: 5,
    },
    folder: {
        data: {},
    },
    sliders: [],
    shoppingcart: [],
    myvippackage: [],
    myextentionpackage: [],
    myfreezeorders: [],
    myproducts: [],
    myfolders: [], //我的全部文件夹
    accountstatus: 0, //账号状态
    accounttype: 0, //账号类型
    freefolder: 0, //免费文件夹数量
    showmsg: '', //登录显示的提示信息
    wxcode: '', //weixincode
    wxstate: '', //weixinstate
    iswxreg: false, //是否微信注册
    iswxbind: false, //是否绑定微信
    wxopenid: '', //weixinopenid
    wxunionid: '', //weixinunionid
    wxgenerateid: '', //weixin用户id  
    showmallbutton: false,
    mallver: '', //用戶商城版本
    iseditacc: false, //是否可以修改账号
    isupbaseproductnotice:false,//是否显示升级到专业版的提示
    maxopendocnum:0,
    opendocnum:0,
    email:'',
    isjxt:false,//jxt临时演示处理
    numberofguide:0,//演示次数

    // firstvippackages:[],//用户当前正在用的vip等级包(续费vip时作为默认参数)
}

const getters = {
    userInfo(state) {
        return state
    },
    getUserId(state) {
        return state.userId
    },
    getUserGuid(state) {
        return state.userGuid
    },
    getRealName(state) {
        return state.realName
    },
    getToken(state) {
        return state.token
    },
    getAccountType() {
        return state.accounttype
    },
    // getUserType(state) {
    //     return state.userType
    // },
    isLogin: function(state) {
        return state.isLogin
    },
    sliderLength: function(state) {
        return state.sliderLength;
    },
    sliderScreen: function(state) {
        return state.screen;
    },
    sta: function(state) {
        return state
    },
    accounttype: function(state) {
        return state.accounttype
    },
    court: function(state) {
        return state.initData.court
    },
    paperword: function(state) {
        return state.initData.paperword
    },
    taxCaseCategory: function(state) {
        return state.initData.taxCaseCategory
    },
    ltree: function(state) {
        return state.initData.leftTree
    },
    ltmtree: function(state) {
        return state.initData.leftTMTree
    },
    industryData: function(state) {
        return state.initData.industry
    },
    taxesData: function(state) {
        return state.initData.taxes
    },
    inOutData: function(state) {
        return state.initData.inOut
    },
    reductionData: function(state) {
        return state.initData.reduction
    },
    reductionTaxData: function(state) {
        return state.initData.reductionTax
    },
    countryData: function(state) {
        return state.initData.country
    },
    provinceCityData: function(state) {
        return state.initData.provinceCity
    },
    offersIndustry: function(state) {
        return state.initData.offersIndustry
    },
    getWorkBook: function(state) {
        return state.workbook
    },
    readFileLength: function(state) {
        // console.log(state.workbook.readfiles)
        return state.workbook.readfiles.length;
    },
    historyFileLength: function(state) {
        return state.workbook.historyfiles.length
    },
    workBookSubmitLeft: function(state) {
        return state.workbook.submitLeft;
    },
    readFileSelectedLength: function(state) {
        return state.workbook.readfilesSelected.length
    },
    readfilesSelected: function(state) {
        return state.workbook.readfilesSelected
    },
    getLeftExpand: function(state) {
        return state.isLeftExpand
    },
    getLoginForm: function(state) {
        return state.popLoginForm
    },
    getFolder(state) {
        return state.folder.data
    },
    getVersion(state) {
        return state.initData.currentVersion
    },
    getMaxFileNum(state){
        return state.maxopendocnum
    },
    getOpenedFileNum(state){
        return state.opendocnum
    },
    getEmail(state){
        return state.email
    }
}

const mutations = {
    setUserId(state, userId) {
        state.userId = userId
    },
    setUserGuid(state, userGuid) {
        state.userGuid = userGuid
    },
    setRealName(state, realName) {
        state.realName = realName
    },
    setToken(state, token) {
        state.token = token
    },
    setIsLogin(state, isLogin) {
        state.isLogin = isLogin
    },
    // setUserType(state, type) {
    //     state.userType = type
    // },
    setCourt(state, court) {
        state.initData.court = court.slice(0)
    },
    setPaperWord(state, paperword) {
        state.initData.paperword = paperword.slice(0)
    },
    setTaxCaseCategory(state, court) {
        state.initData.taxCaseCategory = court.slice(0)
    },
    setIndustry(state, industry) {
        state.initData.industry = industry.slice(0)
    },
    setLeftTree(state, tree) {
        state.initData.leftTree = tree.slice(0)
    },
    setLeftTMTree(state, tree) {
        state.initData.leftTMTree = tree.slice(0)
    },
    setTaxes(state, taxes) {
        state.initData.taxes = taxes.slice(0)
    },
    setInOut(state, inout) {
        state.initData.inOut = inout.slice(0)
    },
    setReduction(state, reduction) {
        state.initData.reduction = reduction.slice(0)
    },

    setReductionTax(state, reductionTax) {
        state.initData.reductionTax = reductionTax.slice(0)
    },
    setReductionIndustry(state, reductionIndustry) {
        state.initData.reductionIndustry = reductionIndustry.slice(0)
    },
    setOffersIndustry(state, offersIndustry) {
        state.initData.offersIndustry = offersIndustry.slice(0)
    },
    setCountry(state, country) {
        state.initData.country = country.slice(0)
    },
    setProvinceCity(state, pc) {
        state.initData.provinceCity = pc.slice(0)
    },
    setBusinessLoginUser(state, userinfo) {
        state.userGuid = userinfo.userGuid
        state.userId = userinfo.userId
        state.mobileNum = userinfo.mobileNum
        state.realName = userinfo.realName
        state.token = userinfo.token
        //企业用户信息
        //state.userType = userinfo.userType
        state.mobileNum = userinfo.mobileNum
        state.permission = userinfo.permission
        state.isLogin = true

        state.accounttype = userinfo.accounttype
        state.accountstatus = userinfo.accountstatus
        state.freefolder = userinfo.freefolder
        state.showmsg = userinfo.showmsg
        state.wxopenid = userinfo.wxopenid
        state.wxunionid = userinfo.wxunionid
        state.wxgenerateid = userinfo.wxgenerateid
        state.showmallbutton = userinfo.showmallbutton
        state.mallver = userinfo.mallver
        state.iseditacc = userinfo.iseditacc
        state.isupbaseproductnotice=userinfo.isupbaseproductnotice
        state.maxopendocnum=userinfo.maxopendocnum,
        state.opendocnum=userinfo.opendocnum
        state.email=userinfo.email
        let d = userinfo
        //VueCookies.set('u', d);
        sessionStorage.setItem("st", JSON.stringify(d));
    },
    setLoginUserProductInfo(state, productinfo) {
        state.myvippackage = productinfo.myvippackage
        state.myextentionpackage = productinfo.myextentionpackage
        state.myproducts = productinfo.myproducts
        let p = productinfo
        sessionStorage.setItem("sp", JSON.stringify(p));
    },
    setLoginUser(state, userinfo) {
        state.userGuid = userinfo.userGuid
        state.userId = userinfo.userId
        state.mobileNum = userinfo.mobileNum
        state.realName = userinfo.realName
        state.token = userinfo.token
        state.isLogin = true
        //state.userType = userinfo.userType
        state.permission = userinfo.permission

        state.accounttype = userinfo.accounttype
        state.accountstatus = userinfo.accountstatus
        state.freefolder = userinfo.freefolder
        state.showmsg = userinfo.showmsg
        state.wxopenid = userinfo.wxopenid
        state.wxunionid = userinfo.wxunionid
        state.wxgenerateid = userinfo.wxgenerateid
        state.showmallbutton = userinfo.showmallbutton
        state.mallver = userinfo.mallver
        state.iseditacc = userinfo.iseditacc
        state.isupbaseproductnotice=userinfo.isupbaseproductnotice
        state.maxopendocnum=userinfo.maxopendocnum
        state.opendocnum=userinfo.opendocnum
        state.email=userinfo.email

        //写入cookie
        //let d={ug:userinfo.userGuid,tk:userinfo.token}
        let d = userinfo
        //VueCookies.set('u', d);
        sessionStorage.setItem("st", JSON.stringify(d));
        //console.log(VueCookies.get('u'))
    },
    setTempUserLogin(state, userinfo) {
        state.userGuid = userinfo.userGuid
        state.userId = userinfo.userId
        state.realName = userinfo.realName
        state.token = userinfo.token
        //state.userType = userinfo.userType
        state.mobileNum = userinfo.mobileNum
        state.isLogin = true
        state.permission = userinfo.permission

        state.accounttype = userinfo.accounttype
        state.accountstatus = userinfo.accountstatus
        state.freefolder = userinfo.freefolder
        state.showmsg = userinfo.showmsg
        state.wxopenid = userinfo.wxopenid
        state.wxunionid = userinfo.wxunionid
        state.wxgenerateid = userinfo.wxgenerateid
        state.showmallbutton = userinfo.showmallbutton
        state.isupbaseproductnotice=userinfo.isupbaseproductnotice

    },
    setTempLoginUser(state, userinfo) {
        state.userGuid = userinfo.userGuid
        state.userId = userinfo.userId
        state.realName = userinfo.realName
        state.token = userinfo.token
        //state.userType = userinfo.userType
        state.mobileNum = userinfo.mobileNum
        state.isLogin = true
        state.permission = userinfo.permission

        state.accounttype = userinfo.accounttype
        state.accountstatus = userinfo.accountstatus
        state.freefolder = userinfo.freefolder
        state.showmsg = userinfo.showmsg
        state.wxopenid = userinfo.wxopenid
        state.wxunionid = userinfo.wxunionid
        state.wxgenerateid = userinfo.wxgenerateid
        state.showmallbutton = userinfo.showmallbutton
        state.isupbaseproductnotice=userinfo.isupbaseproductnotice

    },
    setUserLogout(state) {
        state.userGuid = ''
        state.userId = ''
        state.mobileNum = ''
        state.realnName = ''
        state.token = ''
        //state.userType = ''
        state.permission = []
        state.isLogin = false

        state.accounttype = 0
        state.accountstatus = 0
        state.freefolder = 0
        state.showmsg = ''
        state.mallver = ''
        state.iseditacc = false
        state.isupbaseproductnotice=false
        state.maxopendocnum=0
        state.opendocnum=0
        state.email=''
        //actions.handleTempLogin()
        //console.log(actions)
    },
    // logout(state) {
    //   state.userGuid = ''
    //   state.userId = ''
    //   state.realName = ''
    //   state.token = ''
    //   state.isLogin = false
    // },
    screenSet(state, n) {
        state.screen = n;
    },
    setSliderLength(state, n) {
        state.sliderLength = n;
    },
    setLeftExpand(state, v) {
        state.isLeftExpand = v
    },
    setWorkBook(state, changed) {
        state.workbook.isContentChanged = changed
    },
    addBookRead(state, readoc) {
        var has = state.workbook.readfiles.some((item) => { return item.fileid === readoc.fileid });
        if (!has) {
            state.workbook.readfiles.push(readoc)
        }
    },
    setBookHistoryFiles(state, files) {
        state.workbook.historyfiles = files
    },
    removeBookHistoryFile(state, file) {
        //arr.findIndex(item => item.id === 8)
        var arr = state.workbook.historyfiles
        arr = arr.splice(arr.findIndex(item => item.fileid === file.fileid), 1)
    },
    clearBookRead(state) {
        state.workbook.readfiles = []
    },
    workBookSubmit(state) {
        state.workbook.submitLeft -= 1
    },
    setBookSelectedFiles(state, files) {
        state.workbook.readfilesSelected = files
    },
    setLoginForm(state, value) {
        state.popLoginForm = value
    },
    setSelectNode(state, node) {
        state.selectNode = node
    },
    setCurrentVersion(state, value) {
        state.initData.currentVersion = value
    },
    setMaxFileNum(state,value){
        state.maxopendocnum=value
    },
    setOpenedFileNum(state,value){
        state.opendocnum=value
    },
    setEmail(state,value){
        state.email=value
    }
}

const actions = {
    asynSetUserId({
        commit
    }, userName) {
        setTimeout(() => {
            commit('setUserId', userId)
        }, 1000)
    },
    asyncSetRealName({
        commit
    }, realName) {
        setTimeout(() => {
            commit('setRealName', realName)
        }, 1000)
    },
    asyncSetToken({
        commit
    }, token) {
        setTimeout(() => {
            commit('setToken', token)
        }, 1000)
    },
    // asyncLogout({
    //   commit
    // }) {
    //   setTimeout(() => {
    //     commit('logout')
    //   }, 1000)
    // },
    asyncSetIsLogin({
        commit
    }, isLogin) {
        setTimeout(() => {
            commit('setIsLogin', isLogin)
        }, 1000)
    },
    handleTempUserLogin({
        commit
    }) {
        return new Promise((resolve, reject) => {
            reqTempUserLogin()
                .then(function(resp) {
                    if (resp.rtncode === 1) {
                        if (resp.rltcode === 1) {
                            var tempLoginUser = {
                                userGuid: resp.userguid,
                                userId: resp.userid,
                                mobileNum: resp.mobilenum,
                                realName: resp.realname,
                                token: resp.token,
                                //userType: resp.usertype,
                                // accounttype: resp.accounttype,
                                permission: resp.permission,
                                accounttype: resp.accounttype,
                                accountstatus: resp.accountstatus,
                                freefolder: resp.freefolder,
                                showmsg: resp.showmsg,
                                wxopenid: resp.wxopenid,
                                wxunionid: resp.wxunionid,
                                wxgenerateid: resp.wxgenerateid,
                                showmallbutton: resp.showmallbutton,
                            }
                            //setTempUser
                            commit('setTempUserLogin', tempLoginUser)
                            resolve(resp);
                        } else {
                            reject(resp.rltdesc)
                        }
                    } else {
                        reject(resp.rtndesc)
                    }
                }).catch(function(err) {
                    reject(err)
                })
        })
    },
    handleTempLogin({
        commit
    }) {
        return new Promise((resolve, reject) => {
            // ACCOUNTTYPE_TEMP               AccountType = 0 //临时用户
            // ACCOUNTTYPE_PERSONAL           AccountType = 1 // 个人用户
            // ACCOUNTTYPE_ENTERPRISE         AccountType = 2 // 单位用户
            // ACCOUNTTYPE_ENTERPRISE_FIXEDIP AccountType = 3 // 单位用户(固定IP)
            // ACCOUNTTYPE_GROUPON            AccountType = 4 // 团购用户
            reqTempLogin()
                .then(function(resp) {
                    if (resp.rtncode === 1) {
                        if (resp.rltcode === 1) {
                            var tempLoginUser = {
                                userGuid: resp.userguid,
                                userId: resp.userid,
                                mobileNum: resp.mobilenum,
                                realName: resp.realname,
                                token: resp.token,
                                //userType: resp.usertype,
                                // accounttype: resp.accounttype,
                                permission: resp.permission,

                                accounttype: resp.accounttype,
                                accountstatus: resp.accountstatus,
                                freefolder: resp.freefolder,
                                showmsg: resp.showmsg,
                                wxopenid: resp.wxopenid,
                                wxunionid: resp.wxunionid,
                                wxgenerateid: resp.wxgenerateid,
                                showmallbutton: resp.showmallbutton,
                            }
                            // console.log('tempLoginUser...')
                            // console.log(tempLoginUser)
                            //若session存在则用session数据覆盖
                            //console.log(VueCookies.get('u'))
                            //sessionStorage.st !== undefined
                            //let ck = VueCookies.get('u')
                            if (tempLoginUser.accounttype === 0) {
                                if (sessionStorage.st !== undefined) {
                                    console.log("session登录...")
                                    let ss = JSON.parse(sessionStorage.st)
                                    console.log(ss)
                                    commit('setLoginUser', ss)
                                    //如果存在session中存在用戶产品信息则载入
                                    if (sessionStorage.sp !== undefined) {
                                        console.log("重载sp信息")
                                        let sp = JSON.parse(sessionStorage.sp)
                                        console.log(sp)
                                        commit('setLoginUserProductInfo', sp)
                                    }
                                } else {
                                    commit('setTempLoginUser', tempLoginUser)
                                }
                            } else if (tempLoginUser.accounttype === 3) {
                                commit('setBusinessLoginUser', tempLoginUser)
                            }


                            // if (ss !== null) {

                            //   //let loginUser = JSON.parse(sessionStorage.st)
                            //   //store.commit('setLoginUser', loginUser)

                            // } else {

                            // }

                            // commit('setUserGuid', resp.userguid)
                            // commit('setRealName', '访客')
                            // commit('setToken', resp.token)
                            // commit('setIsLogin', true)

                            resolve(resp);
                        } else {
                            reject(resp.rltdesc)
                        }
                    } else {
                        reject(resp.rtndesc)
                    }
                }).catch(function(err) {
                    reject(err)
                })
        })
    },
    handleLogin({
        commit
    }, payload) {
        //console.log(payload)
        //userId = userId.trim()
        //console.log("h:"+userId+tempguid+password)
        return new Promise((resolve, reject) => {
            // console.log("login payload...")
            // console.log(payload)
            reqLogin(payload)
                .then(function(resp) {
                    console.log(resp)
                    if (resp.rtncode === 1) {
                        if (resp.rltcode === 1) {
                            console.log('login success...')
                            var loginUser = {
                                userGuid: resp.userguid,
                                userId: resp.userid,
                                mobileNum: resp.mobilenum,
                                realName: resp.realname,
                                token: resp.token,
                                userType: resp.userid, //手动登录成功，将用户id写入userType,以区别临时用户,普通用户和企业用户
                                //accounttype: resp.accounttype, //  0-临时用户, 1-个人用户,2-单位用户, 3-单位用户(固定IP),4-团购用户
                                permission: resp.permission,

                                accounttype: resp.accounttype,
                                accountstatus: resp.accountstatus,
                                freefolder: resp.freefolder,
                                showmsg: resp.showmsg,
                                wxopenid: resp.wxopenid,
                                wxunionid: resp.wxunionid,
                                wxgenerateid: resp.wxgenerateid,
                                showmallbutton: resp.showmallbutton,
                                mallver: resp.mallver,
                                iseditacc: resp.isallowedituserid,
                                isupbaseproductnotice:resp.isupbaseproductnotice,
                                maxopendocnum:resp.maxopendocnum,
                                opendocnum:resp.opendocnum,
                                email:resp.email,
                            }
                            commit('setLoginUser', loginUser)
                            //sessionStorage.setItem("st", JSON.stringify(loginUser));
                            resolve(resp);
                        } else {
                            //reject(resp.rltdesc)
                            reject(resp)
                        }
                    } else {
                        //reject(resp.rtndesc)
                        reject(resp)
                    }
                }).catch(function(err) {
                    reject(err)
                })
        })
    },
    flashToken({
        commit
    }, payload) {
        //console.log(payload)
        //userId = userId.trim()
        //console.log("h:"+userId+tempguid+password)
        return new Promise((resolve, reject) => {
            // console.log("login payload...")
            // console.log(payload)
            refreshToken()
                .then(function(resp) {
                    console.log(resp)
                    if (resp.rtncode === 1) {
                        if (resp.rltcode === 1) {
                            console.log('flash toekn success...')
                            var loginUser = {
                                userGuid: resp.userguid,
                                userId: resp.userid,
                                mobileNum: resp.mobilenum,
                                realName: resp.realname,
                                token: resp.token,
                                userType: resp.userid, //手动登录成功，将用户id写入userType,以区别临时用户,普通用户和企业用户
                                //accounttype: resp.accounttype, //  0-临时用户, 1-个人用户,2-单位用户, 3-单位用户(固定IP),4-团购用户
                                permission: resp.permission,

                                accounttype: resp.accounttype,
                                accountstatus: resp.accountstatus,
                                freefolder: resp.freefolder,
                                showmsg: resp.showmsg,
                                wxopenid: resp.wxopenid,
                                wxunionid: resp.wxunionid,
                                wxgenerateid: resp.wxgenerateid,
                                showmallbutton: resp.showmallbutton,
                                mallver: resp.mallver,
                                iseditacc: resp.isallowedituserid,
                                isupbaseproductnotice:resp.isupbaseproductnotice,
                                maxopendocnum:resp.maxopendocnum,
                                opendocnum:resp.opendocnum,
                                email:resp.email,
                            }
                            commit('setLoginUser', loginUser)
                            //sessionStorage.setItem("st", JSON.stringify(loginUser));

                            resolve(resp);
                        } else {
                            reject(resp.rltdesc)
                        }
                    } else {
                        reject(resp.rtndesc)
                    }
                }).catch(function(err) {
                    reject(err)
                })
        })
    },

    tokenLogin({
        commit
    }, payload) {
        console.log('token login:'+payload.xtoken)
        return new Promise((resolve, reject) => {
            regTokenLogin(payload)
                .then(function(resp) {
                    console.log(resp)
                    if (resp.rtncode === 1) {
                        if (resp.rltcode === 1) {
                            console.log('token login success...')
                            var loginUser = {
                                userGuid: resp.userguid,
                                userId: resp.userid,
                                mobileNum: resp.mobilenum,
                                realName: resp.realname,
                                token: resp.token,
                                userType: resp.userid,
                                permission: resp.permission,
                                accounttype: resp.accounttype,
                                accountstatus: resp.accountstatus,
                                freefolder: resp.freefolder,
                                showmsg: resp.showmsg,
                                wxopenid: resp.wxopenid,
                                wxunionid: resp.wxunionid,
                                wxgenerateid: resp.wxgenerateid,
                                showmallbutton: resp.showmallbutton,
                                mallver: resp.mallver,
                                iseditacc: resp.isallowedituserid,
                                isupbaseproductnotice:resp.isupbaseproductnotice,
                                maxopendocnum:resp.maxopendocnum,
                                opendocnum:resp.opendocnum,
                                email:resp.email,
                            }
                            commit('setLoginUser', loginUser)
                            resolve(resp);
                        } else {
                            reject(resp.rltdesc)
                        }
                    } else {
                        reject(resp.rtndesc)
                    }
                }).catch(function(err) {
                    reject(err)
                })
        })
    },
    handleSetIndustry(context, args) {
        context.commit('setIndustry', args)
    },
    handleSetTax(context, args) {
        context.commit('setTaxes', args)
    },
    handleSetInOut(context, args) {
        context.commit('setInOut', args)
    },
    handleSetReduction(context, args) {
        context.commit('setReduction', args)
    },
    handleSetReduction_tax(context, args) {
        context.commit('setReductionTax', args)
    },
    handleSetReduction_industry(context, args) {
        context.commit('setReductionIndustry', args)
    },
    handleSetOffers_industry(context, args) {
        context.commit('setOffersIndustry', args)
    },
    handleSetCountry(context, args) {
        context.commit('setCountry', args)
    },
    handleSetProvinceCity(context, args) {
        context.commit('setProvinceCity', args)
    },
    handleSetCourt(context, args) {
        context.commit('setCourt', args)
    },
    handleSetPaperword(context, args) {
        context.commit('setPaperWord', args)
    },
    handleSetCourt(context, args) {
        context.commit('setTaxCaseCategory', args)
    },
    handleSetTree(context, args) {
        context.commit('setLeftTree', args)
    },
    handleSetTMTree(context, args) {
        context.commit('setLeftTMTree', args)
    },
    handleSetLoginUserinfo(context, args) {
        context.commit('setLoginUser', args)
    },
    handleSetUserLogout({ dispatch, commit }) {
        console.log('clear session...')
        commit('setUserLogout')
        sessionStorage.clear()
        
        if (state.isjxt){
            //const host = window.location.host
            let hosturl ='/home?g=1'
            console.log(hosturl)
            window.location.assign(hosturl);
        }else{
            window.location.reload()
        }
        //dispatch('handleTempLogin')
        //commit('handleTempLogin')
        // dispatch('handleTempLogin').then(() => {
        //   //commit('someOtherMutation')
        // })
        //dispatch('handleTempLogin')
    },
    handleSetWorkBook(context, args) {
        context.commit('setWorkBook', args)
    },
    handleSetBookRead(context, args) {
        context.commit('addBookRead', args)
    },
    handleSetBookHistoryFiles(context, args) {
        context.commit('setBookHistoryFiles', args)
    },
    handleRemoveBookHistoryFiles(context, args) {
        context.commit('removeBookHistoryFile', args)
    },
    handleClearBookRead(context) {
        context.commit('clearBookRead')
    },
    handleWorkBookSumit(context) {
        context.commit('workBookSubmit')
    },
    handleSetBookReadSelectedFiles(context, args) {
        context.commit('setBookSelectedFiles', args)
    },
    handleSetIsLeftExpand(context, args) {
        context.commit('setLeftExpand', args)
    },
    handleSetCurrentVersion(context, args) {
        context.commit('setCurrentVersion', args)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}